module.exports = __webpack_public_path__ + "img/切片-48.53b92666.jpg";